/** Shopify CDN: Minification failed

Line 24:0 Transforming const to the configured target environment ("es5") is not supported yet

**/
$(document).ready(function(){
  
});

$('#Navigation-drawer-header').on('click', function () {
    $(body).toggleClass('menu-open')
});

//Match title height

function MatchHeight() {
  
	$(".product-card__title").matchHeight();
    $(".card-product .card-product__title").matchHeight();
	$(" .section-trust-indicators__content span.section-trust-indicators__decorator").matchHeight();
	$(".cst-index section.home-trust-indicators .section-trust-indicators__tile .section-trust-indicators__content h3.section-trust-indicators__title").matchHeight();
	//$("section.home-trust-indicators .section-trust-indicators__tile .section-trust-indicators__content h3.section-trust-indicators__title").matchHeight();
    $(".card-article__content h4.card-article__title").matchHeight();  
   
}
MatchHeight();

$(window).on("load", function () {  
  MatchHeight();
});

const timeID = setInterval(matchheight2, 5000);
function matchheight2() {
  $(".product-card__title").matchHeight();
  $(".card-product .card-product__title").matchHeight();
  $(" .section-trust-indicators__content span.section-trust-indicators__decorator").matchHeight(); 
  $(".cst-index section.home-trust-indicators .section-trust-indicators__tile .section-trust-indicators__content h3.section-trust-indicators__title").matchHeight(); 
  //$("section.home-trust-indicators .section-trust-indicators__tile .section-trust-indicators__content h3.section-trust-indicators__title").matchHeight();
  $(".card-article__content h4.card-article__title").matchHeight();  
}
$(window).on("load", function () {    
 matchheight2();
});

$(".contactForm-phone").keypress(function (e) {      
var charCode = (e.which) ? e.which : event.keyCode    
if (String.fromCharCode(charCode).match(/[^0-9]/g))    
    return false;                        
}); 

